// Import the zustand store instance
import useQuoteStore from "../store/QuoteStore";
import useAppStateStore from "../../../shared/store/AppStateStore";
import {
  deformatMonthT,
  deformatYearT,
  formatDateT,
} from "../../../shared/utils/formatters";
import { updateQuoteFields } from "../../../shared/utils/storeUtils";

const Tq4Mapper = {
  get() {
    const STATE = useAppStateStore.getState();
    const additionalDriver = STATE.additionalDriver;
    const driver = useQuoteStore.getState().quote?.risk?.drivers?.[0] ?? {};
    const vehicle = useQuoteStore.getState().quote?.risk?.vehicles?.[0] ?? {};
    const qualification = driver?.qualifications?.[0] ?? {};

    return {
      bonus: vehicle?.ncdDetails?.years
        ? {
            value: vehicle?.ncdDetails?.years?.toString(),
          }
        : null,
      NoClaimBonus:
        vehicle?.ncdDetails?.protected === true
          ? "Yes"
          : vehicle?.ncdDetails?.protected === false
          ? "No"
          : null,
      LicenseAuth: vehicle?.operatingArea
        ? { value: vehicle.operatingArea }
        : null,
      datePassedMonth: qualification?.datePassed
        ? { value: deformatMonthT(qualification.datePassed) }
        : null,
      datePassedYear: qualification?.datePassed
        ? { value: deformatYearT(qualification.datePassed) }
        : null,
      vehicleUse: driver.vehicleUseId ?? null,
      insuranceDeclined:
        driver.insuranceCancelled === null
          ? null
          : driver.insuranceCancelled
          ? "Yes"
          : "No",
      convictedCharged:
        driver.criminalConvictions === null
          ? null
          : driver.criminalConvictions
          ? "Yes"
          : "No",
      addAdditionalDriver: additionalDriver ?? null,
    };
  },

  set(data) {
    const STATE = useAppStateStore.getState();
    const setAdditionalDriver = STATE.setAdditionalDriver;
    const quote = useQuoteStore.getState().quote ?? {};
    const datePassed = `${data.datePassedYear?.value}/${data.datePassedMonth?.value}/01`;
    updateQuoteFields({
      "risk.vehicles.0.ncdDetails.years": data?.bonus?.value,
      "risk.vehicles.0.ncdDetails.protected":
        data.NoClaimBonus === "Yes" ?? false,
      "risk.vehicles.0.ncdDetails.noNcdReasonId": "0",
      "risk.vehicles.0.ncdDetails.entitlementReasonId": "13",
      "risk.vehicles.0.ncdDetails.typeId": null,
      "risk.vehicles.0.ncdDetails.countryEarnedId": "GB",
      "risk.vehicles.0.ncdDetails.dateExpiry":
        quote?.risk?.startDate ?? formatDateT("1899/12/31"),
      "risk.vehicles.0.operatingArea": data.LicenseAuth?.value,
      "risk.drivers.0.vehicleUseId": data.vehicleUse,
      "risk.drivers.0.qualifications.0.datePassed": formatDateT(datePassed),
      "risk.drivers.0.qualifications.0.qualificationId":
        data.vehicleUse == "17" ? "6I3" : "6I4",
      "risk.drivers.0.insuranceCancelled": data.insuranceDeclined === "Yes",
      "risk.drivers.0.criminalConvictions": data.convictedCharged === "Yes",
    });
    setAdditionalDriver(data.addAdditionalDriver);
    if (data.addAdditionalDriver === "No") {
      const mainDriver = quote.risk.drivers.find(
        (driver) => driver && driver.mainUser === true
      );
      if (mainDriver) {
        updateQuoteFields({ "risk.drivers": [mainDriver] });
      }
    }
  },
};

export default Tq4Mapper;
